import React, { useState, useEffect } from 'react';

import BonusCloseIcon from '@/shared/assets/bonus-close-icon.svg';
import { Box } from '@/shared/ui/box';
import { resolveMediaPath } from '@/shared/libs/resolve-media-path';
import { Button } from '@/shared/ui/form/button';
import { Condition } from '@/shared/ui/condition';
import { BonusActions } from '@/flat-pages/bonuses/ui';
import {
  BonusGamesAndProviders,
} from '@/flat-pages/bonuses/ui';

import {
  BodyTextBoldPrimary,
  BodyTextBoldSecondary,
} from '@/shared/ui/typography';
import {
  HeadingBoldH5,
  HeadingMediumH5,
  BodyTextRegularB,
} from '@/shared/ui/typography2';

import {
  StyledAlertDialogOverlay,
  StyledAlertDialogContent,
} from '@/features/auth-managment/styles';

import { WithdrawButton } from '@/features/wallet-managment/ui/fiat-form/styles';

import { OptionsBlock } from './components/options-block';
import { ConditionBlock } from './components/condition-block';

import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import * as Dialog from '@radix-ui/react-dialog';
import { useLocaleFormat } from '@/shared/hooks';

import {
  BonusDetails,
  BonusDialogContent,
  BonusImage,
  BonusItem,
} from '../../styles';

export const BonusViewModal = ({
  bonus,
  onClose,
  mobileLandscape,
  t,
  tCommon,
  providers,
  games,
  router,
  locale,
  notifications,
  onActivate,
  burnOpenClickHandler,
  updateDate,
}) => {
  if (!bonus) return null;

  const [conditionActve, setConditionActve] = useState(null);
  const [timeLoading, setTimeLoading] = useState(true);
  const formatUrl = useLocaleFormat();

  useEffect(() => {
    const bonusState = bonus?.state;
    const shouldSetTimer =
      bonusState !== 'available' && bonusState !== 'active';

    if (shouldSetTimer) {
      const timer = setTimeout(() => {
        setTimeLoading(false);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [bonus?.state]);

  useEffect(() => {
    if (!conditionActve && bonus?.options?.length) {
      setConditionActve(bonus?.options?.length - 1);
    }
    return () => {
      setConditionActve(null);
    };
  }, [bonus]);

  return (
    <Dialog.Root open={bonus?.id} onOpenChange={() => onClose()}>
      <Dialog.Portal>
        <StyledAlertDialogOverlay onClick={onClose} />
        <StyledAlertDialogContent
        >
          <BonusDialogContent $modBonus={true}>
            <VisuallyHidden>
              <Dialog.Title>bonuce view</Dialog.Title>
            </VisuallyHidden>
            <BonusItem
            $isActive={bonus?.state === 'active'}
            // $generateBg={generateBg(bonus)}
            >
              <BonusImage
                $dialogMode={true}
                $imageUrl={resolveMediaPath(bonus?.pic)}
              >
                <Box
                  $position="absolute"
                  $right="12px"
                  $top="12px"
                  $cursor="pointer"
                >
                  <BonusCloseIcon onClick={onClose} />
                </Box>
                <Box
                  $position="absolute"
                  $top="42px"
                  $padding="18px"
                  $textAlign="center"
                  $width="100%"
                >
                  <HeadingBoldH5>{bonus?.name}</HeadingBoldH5>
                </Box>
              </BonusImage>

              <BonusDetails >
                <OptionsBlock
                  options={bonus?.options}
                  changeConditionActve={setConditionActve}
                  conditionActve={conditionActve}
                  mobileLandscape={mobileLandscape}
                  t={t}
                />
                <ConditionBlock
                  options={bonus?.options}
                  conditionActve={conditionActve}
                />

                <BonusGamesAndProviders
                  bonus={bonus}
                  providers={providers}
                  games={games}
                  tCommon={tCommon}
                  t={t}
                  router={router}
                  locale={locale}
                />

                {/* <DescriptionWrapper> */}
                <HeadingMediumH5>{t('card.modal_desc')}</HeadingMediumH5>

                <BodyTextRegularB
                  color="#fff"
                  dangerouslySetInnerHTML={{
                    __html: bonus?.description,
                  }}
                />

                {/* </DescriptionWrapper> */}

                <Condition
                  match={
                    bonus?.state !== 'available' && bonus?.state !== 'active'
                  }
                >
                  <Box
                    $display="flex"
                    $gap={8}
                    $alignItems="center"
                    $height={48}
                    $position="absolute"
                    $zIndex="5"
                    $bottom="18px"
                    $width="calc(100% - 36px)"
                    className="customBtn"
                  >
                    <WithdrawButton
                      style={{ flexGrow: '1' }}
                      $isLoading={timeLoading}
                      variant="gray"
                      disabled={true}
                    >
                      <BonusActions
                        bonus={bonus}
                        updateDate={updateDate}
                        t={t}
                        locale={locale}
                      />
                    </WithdrawButton>
                  </Box>
                </Condition>

                <Condition match={bonus?.state == 'available'}>
                  <Box
                    $display="flex"
                    $gap={8}
                    $alignItems="center"
                    $height={48}
                    $position="absolute"
                    $zIndex="5"
                    $bottom="18px"
                    $width="calc(100% - 36px)"
                  >
                    <Button
                      fill
                      disabled={
                        notifications?.transaction?.bonusID &&
                        notifications?.transaction?.status === 'pending'
                      }
                      variant={
                        notifications?.transaction?.bonusID &&
                        notifications?.transaction?.status === 'pending'
                          ? 'danger'
                          : 'orangeGradient'
                      }
                      onClick={() => {
                        onActivate(bonus);
                        onClose();
                      }}
                      isLoading={
                        notifications?.transaction?.bonusID &&
                        notifications?.transaction?.status === 'pending'
                      }
                    >
                      <Condition
                        match={
                          !notifications?.transaction?.bonusID ||
                          notifications?.transaction?.status !== 'pending'
                        }
                      >
                        <BodyTextBoldSecondary>
                          {t('card.button_active')}
                        </BodyTextBoldSecondary>
                      </Condition>
                    </Button>
                  </Box>
                </Condition>

                <Condition match={bonus?.state === 'active'}>
                  <Box
                   $display="flex"
                   $gap={8}
                   $alignItems="center"
                   $height={48}
                   $position="absolute"
                   $zIndex="5"
                   $bottom="18px"
                   $width="calc(100% - 36px)"
                  >
                    <Button
                      style={{ flexGrow: '1' }}
                      fill
                      variant="danger"
                      disabled={Boolean(
                        notifications?.transaction?.bonusID &&
                          notifications?.transaction?.status === 'pending'
                      )}
                      onClick={() => {
                        burnOpenClickHandler(bonus);
                        onClose();
                      }}
                    >
                      <Box>
                        <BodyTextBoldSecondary>
                          {t('burn_modal.burn')}
                        </BodyTextBoldSecondary>
                      </Box>
                    </Button>
                    <Button
                      style={{ flexGrow: '2' }}
                      fill
                      variant="orangeGradient"
                      disabled={Boolean(
                        notifications?.transaction?.bonusID &&
                          notifications?.transaction?.status === 'pending'
                      )}
                      onClick={() => {
                        if (
                          !notifications?.bonusInfo?.provider &&
                          !notifications?.bonusInfo?.games &&
                          notifications?.bonus?.isActive
                        ) {
                          router.push(formatUrl('/'));
                        } else {
                          router.push(formatUrl('/games?filter=bonus'));
                        }
                      }}
                    >
                      <Box>
                        <BodyTextBoldPrimary>
                          {t('card.to_games')}
                        </BodyTextBoldPrimary>
                      </Box>
                    </Button>
                  </Box>
                </Condition>
              </BonusDetails>
            </BonusItem>
          </BonusDialogContent>
        </StyledAlertDialogContent>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
